import { CheckCircle } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import clsx from 'clsx';

interface AssignmentFactualClaimsProps {
  claims?: string | null;
  className?: string;
}

export function AssignmentFactualClaims({
  claims,
  className,
}: AssignmentFactualClaimsProps) {
  const items =
    claims
      ?.split('\n')
      .map(c => c.trim())
      .filter(Boolean) || [];

  const hasClaims = items.length > 0;

  return (
    <div className={clsx('w-full space-y-3 mt-4', className)}>
      {hasClaims ? (
        <div className='grid grid-cols-1 sm:grid-cols-2 gap-3 w-full'>
          {items.map((text, index) => (
            <Card key={index} className='p-3 w-full'>
              <CardContent className='p-0 flex flex-col gap-2'>
                <div className='flex items-start gap-2'>
                  <CheckCircle className='h-4 w-4 mt-1 text-muted-foreground shrink-0' />
                  <p className='text-sm text-left leading-snug'>{text}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <Card className='p-3 min-h-[80px]'>
          <div className='flex items-center justify-center p-0 h-full text-sm text-muted-foreground'>
            No factual claims available
          </div>
        </Card>
      )}
    </div>
  );
}
